import qualityBadges from "@/assets/quality-badges.png";

export function UnfailingGoods() {
  return (
    <section className="bg-[#E8DCC4] py-24 md:py-32">
      <div className="mx-auto max-w-[1200px] px-6 text-center">
        <h2 className="font-heading text-5xl font-black uppercase leading-[0.95] tracking-tight text-primary sm:text-6xl md:text-7xl">
          Quality Goods
          <br />
          Since 1992
        </h2>

        <div className="mt-16 flex justify-center">
          <img
            src={qualityBadges}
            alt="Dadgum best guarantee, free U.S. shipping on orders over $75, returnable within 30 days"
            className="w-full max-w-[1000px] h-auto"
          />
        </div>
      </div>
    </section>
  );
}
